import { Position } from "@/services/backend/vbs/treatments/types/position";
import { useState } from "react";
import {
  UpdateCycleRequest,
  useVbsTreatmentUpdateCycleMutation,
} from "@/services/backend/vbs/treatments/api/treatment-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { IntNumberInput } from "@/routes/processes/_components/ui/number-input";

export function CycleCell({
  treatmentId,
  position,
  disabled = false,
}: {
  treatmentId: string;
  position: Position;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateCycleRequest>({
    id: treatmentId,
    positionId: position.id,
    cycle: position.cycle,
  });
  const mutation = useVbsTreatmentUpdateCycleMutation();
  useDebouncedMutation(request, setRequest, mutation, {
    id: treatmentId,
    positionId: position.id,
    cycle: position.cycle,
  });

  return (
    <div className="whitespace-nowrap">
      <IntNumberInput
        value={request.cycle}
        onChange={(cycle) => setRequest({ ...request, cycle })}
        disabled={disabled}
      />
      <span className="ml-1">Wo.</span>
    </div>
  );
}
